import { axios } from "utils";

import { ADMIN_FILES_URL as endpoint } from "consts";

// uploading files for admins only
const uploadAdminFile = async (data) => axios.post(`${endpoint}`, { data });

export const addAdminFile = async (data) => {
  const reader = new FileReader();
  const type = data.file.name.split(".").pop().toLowerCase();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      uploadAdminFile({
        file: reader.result,
        location: data.location ? data.location : "uploads",
        type,
      }).then((res) => {
        resolve(res);
      });
    };
    reader.readAsDataURL(data.file);
  });
};

export const downloadS3File = async (location) => axios.get(`${endpoint}/file`, { data: { location }, responseType: "arraybuffer" });

export const proxyDownloadFile = async (location) => axios.get(`${endpoint}/proxy`, { data: { location }, responseType: "arraybuffer" });
